export default "/images/1c0358e873ccdc9ecc94e65a1f4309a6.avif";